import { UserSessionDocument } from 'platform/__generated__/userSession.query';
import { preloadQuery } from 'setupClient';

export const authQueryRef = preloadQuery(UserSessionDocument, { errorPolicy: 'all' });
